// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/Inter-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/Inter-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/Inter-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primary-color: hsl(0, 0%, 0%);
    --secondary-color: #FF5500;
    --background-color: rgb(255 251 251 / 30%);
    --card-color: #ffffff;
    --text-color: #1A1A2E;
    --text-light: #4A4A65;
    --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.08);
    --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.12);
    --radius-sm: 6px;
    --radius-md: 12px;
    --radius-lg: 24px;
    --transition: all 0.2s ease;
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

@font-face {
    font-family: 'Inter';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Inter';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Inter';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
}

body {
    background-color: var(--background-color);
    color: var(--text-color);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    padding: 2rem;
    line-height: 1.6;
}

.container {
    max-width: 1000px;
    width: 100%;
    background-color: var(--card-color);
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-md);
    padding: 3rem;
    margin-bottom: 3rem;
}

h1 {
    text-align: center;
    margin-bottom: 0.75rem;
    color: var(--primary-color);
    font-weight: 600;
    font-size: 2.5rem;
    line-height: 1.2;
}

h2 {
    text-align: center;
    color: var(--text-light);
    font-weight: 500;
    font-size: 1.25rem;
    margin-bottom: 2rem;
}

.feature-tags {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.5rem;
    margin-bottom: 1.5rem;
}

.feature-tag {
    background-color: rgba(0, 80, 255, 0.1);
    color: var(--primary-color);
    padding: 0.4rem 1rem;
    border-radius: 100px;
    font-size: 0.875rem;
    font-weight: 500;
}

.info-message {
    text-align: center;
    margin-bottom: 1.5rem;
    color: var(--text-light);
    font-size: 1.1rem;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
}

.instructions {
    color: var(--text-light);
    text-align: center;
    margin-bottom: 2rem;
    font-size: 0.95rem;
}

.upload-area {
    border: 2px dashed rgba(0, 0, 0, 0.1);
    border-radius: var(--radius-md);
    padding: 3rem 2rem;
    text-align: center;
    cursor: pointer;
    margin-bottom: 2rem;
    transition: var(--transition);
    background-color: rgba(0, 0, 0, 0.02);
}

.upload-area:hover {
    border-color: var(--primary-color);
    background-color: rgba(0, 80, 255, 0.05);
}

.upload-area p {
    margin-top: 1rem;
    color: var(--text-light);
}

.upload-icon {
    font-size: 3rem;
    color: var(--primary-color);
}

.upload-icon svg {
    width: 60px;
    height: 60px;
}

.browse-link {
    color: var(--primary-color);
    font-weight: 500;
    cursor: pointer;
    text-decoration: underline;
}

.supported-formats {
    font-size: 0.8rem;
    color: var(--text-light);
    opacity: 0.8;
    margin-top: 0.75rem;
}

.controls {
    display: flex;
    justify-content: center;
    margin-top: 2rem;
}

button {
    padding: 0.875rem 2rem;
    background-color: var(--primary-color);
    color: #fff;
    border: none;
    border-radius: var(--radius-sm);
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: var(--transition);
    min-width: 180px;
}

button:hover {
    background-color: #0040CC;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 80, 255, 0.3);
}

button:disabled {
    background-color: #BBC3D8;
    cursor: not-allowed;
    box-shadow: none;
    transform: none;
}

.video-preview {
    margin-top: 2rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #000;
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-sm);
    aspect-ratio: 16/9;
    position: relative;
    overflow: hidden;
}

.video-preview video {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.error-message {
    background-color: #FFF5F5;
    color: #E53E3E;
    padding: 0.5rem;
    font-size: 0.8rem;
    border-radius: var(--radius-sm);
    text-align: center;
    margin-bottom: 1.5rem;
    border-left: 4px solid #E53E3E;
}

.hidden {
    display: none;
}

.file-name {
    margin-top: 1rem;
    font-size: 0.95rem;
    color: var(--text-light);
    font-weight: 500;
}

/* Tab styling */
.tab-container {
    margin-top: 2rem;
    width: 100%;
    background-color: #F7FAFC;
    border-radius: var(--radius-md);
    overflow: hidden;
}

.tabs {
    display: flex;
    background-color: #F1F5FB;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.tab-button {
    padding: 1rem 1.5rem;
    background-color: transparent;
    color: var(--text-light);
    border: none;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: var(--transition);
    flex: 1;
    text-align: center;
    border-bottom: 3px solid transparent;
    min-width: auto;
    padding-top: 8px;
    padding-bottom: 8px;
}

.tab-button:hover {
    background-color: rgba(0, 80, 255, 0.05);
    color: var(--primary-color);
}

.tab-button.active {
    border-bottom: 3px solid var(--primary-color);
    color: var(--primary-color);
    background-color: rgba(0, 80, 255, 0.08);
}

.tab-content {
    padding: 1.5rem;
}

.tab-pane {
    display: none;
    padding: 1.5rem;
    background-color: #FFFFFF;
    border-radius: var(--radius-sm);
    box-shadow: var(--shadow-sm);
}

.tab-pane.active {
    display: block;
    animation: fadeIn 0.3s;
}

/* Trim controls */
.select-container {
    position: relative;
}

select {
    width: 100%;
    padding: 0.875rem;
    border-radius: var(--radius-sm);
    border: 1px solid rgba(0, 0, 0, 0.1);
    background-color: #fff;
    font-size: 1rem;
    cursor: pointer;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    color: var(--text-color);
}

.select-container::after {
    content: '▼';
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    font-size: 0.8rem;
    color: var(--text-light);
}

.hero-description {
    text-align: center;
    margin-bottom: 2rem;
    font-size: 1.1rem;
    color: var(--text-light);
}

.trim-slider-container {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
}

.trim-slider {
    position: relative;
    height: 10px;
    background-color: #E2E8F0;
    border-radius: 5px;
    margin: 2rem 0;
}

.trim-handle {
    position: absolute;
    width: 26px;
    height: 26px;
    background-color: var(--primary-color);
    border-radius: 50%;
    top: -8px;
    transform: translateX(-50%);
    cursor: pointer;
    z-index: 5;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
    border: 2px solid #fff;
    touch-action: none;
}

.trim-handle.start {
    left: 0;
    transform: translateX(-50%);
    background-color: #E53E3E;
    z-index: 2; /* Higher z-index to ensure it's on top */

}

.trim-handle.end {
    left: 100%;
    transform: translateX(-50%);
    background-color: #cab8b8;
    z-index: 1; /* Higher z-index to ensure it's on top */

}

.trim-progress {
    position: absolute;
    height: 10px;
    background-color: rgba(0, 80, 255, 0.3);
    border-radius: 5px;
}

.trim-timestamps {
    display: flex;
    justify-content: space-between;
}

.trim-time {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.trim-time label {
    font-weight: 500;
    color: var(--text-color);
}

.time-input {
    width: 120px;
    padding: 0.75rem;
    font-size: 0.75rem;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: var(--radius-sm);
    text-align: center;
    font-family: monospace;
}

.secondary-button {
    padding: 0.75rem 1.5rem;
    background-color: var(--secondary-color);
    color: #fff;
    border: none;
    border-radius: var(--radius-sm);
    font-size: 0.95rem;
    font-weight: 500;
    cursor: pointer;
    transition: var(--transition);
    align-self: flex-end;
    min-width: 150px;
}

.secondary-button:hover {
    opacity: 0.9;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(255, 85, 0, 0.3);
}

/* Audio extract styling */
.audio-format-container {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    align-items: center;
    padding: 2rem 0;
}

/* Spinner */
.spinner-container {
    display: none;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 1rem;
    margin: 1rem 0;
}

#loading {
    display: inline-block;
    width: 60px;
    height: 60px;
    border: 3px solid rgba(0, 80, 255, 0.2);
    border-radius: 50%;
    border-top-color: var(--primary-color);
    animation: spin 1s ease-in-out infinite;
    -webkit-animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

@-webkit-keyframes spin {
    to {
        -webkit-transform: rotate(360deg);
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

.loading-message {
    color: var(--text-light);
    font-size: 0.9rem;
    font-weight: 500;
    text-align: center;
    animation: pulse 1.5s infinite;
}

@keyframes pulse {
    0% { opacity: 0.6; }
    50% { opacity: 1; }
    100% { opacity: 0.6; }
}

/* Feature info cards */
.how-it-works-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 1.5rem;
    margin-top: 3.5rem;
}

.info-card {
    background-color: #fff;
    border-radius: var(--radius-md);
    padding: 1.75rem;
    box-shadow: var(--shadow-sm);
    transition: var(--transition);
    border: 1px solid rgba(0, 0, 0, 0.05);
}

.info-card:hover {
    transform: translateY(-5px);
    box-shadow: var(--shadow-md);
    border-color: rgba(0, 80, 255, 0.1);
}

.info-card h3 {
    margin-bottom: 1rem;
    color: var(--primary-color);
    font-weight: 600;
    font-size: 1.25rem;
}

.info-card p {
    color: var(--text-light);
    margin-bottom: 1rem;
    line-height: 1.6;
}

.learn-more {
    display: inline-flex;
    align-items: center;
    margin-top: 1rem;
    color: var(--primary-color);
    text-decoration: none;
    font-size: 0.95rem;
    font-weight: 500;
    gap: 0.25rem;
}

.learn-more:hover {
    text-decoration: underline;
}

.learn-more::after {
    content: "→";
    transition: var(--transition);
}

.learn-more:hover::after {
    transform: translateX(3px);
}

/* Buy me coffee */
.buy-me-coffee {
    display: flex;
    justify-content: center;
    margin-top: 2rem;
}

.feedback-container {
    display: flex;
    justify-content: center;
    margin-top: 1rem;
}

.feedback-button {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1.5rem;
    background-color: var(--card-color);
    color: var(--text-color);
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: var(--radius-sm);
    font-size: 0.95rem;
    font-weight: 500;
    cursor: pointer;
    transition: var(--transition);
    box-shadow: var(--shadow-sm);
}

.feedback-button:hover {
    background-color: rgba(0, 0, 0, 0.02);
    border-color: var(--primary-color);
    transform: translateY(-1px);
    box-shadow: var(--shadow-md);
}

.feedback-button svg {
    color: var(--primary-color);
}

/* Trust indicators - New section */
.trust-indicators {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 2.5rem;
    margin: 3rem auto;
    max-width: 700px;
}

.trust-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

.trust-number {
    font-size: 2.5rem;
    font-weight: 700;
    color: var(--primary-color);
    margin-bottom: 0.5rem;
}

.trust-label {
    font-size: 1rem;
    color: var(--text-light);
    font-weight: 500;
}

/* Privacy badge */
.privacy-badge {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    background-color: rgba(0, 80, 255, 0.05);
    color: var(--primary-color);
    padding: 0.75rem 1.5rem;
    border-radius: 100px;
    margin: 2rem auto;
    max-width: max-content;
}

.privacy-icon {
    flex-shrink: 0;
}

/* Popup Styles */
.popup-overlay {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    align-items: center;
    justify-content: center;
    padding: 1rem;
}

.popup-overlay.active {
    display: flex;
}

.popup-content {
    background-color: var(--card-color);
    border-radius: var(--radius-md);
    padding: 2rem;
    width: 100%;
    max-width: 500px;
    position: relative;
    box-shadow: var(--shadow-md);
    animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
    from {
        transform: translateY(-20px);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
}

.close-button {
    position: absolute;
    top: 1rem;
    right: 1rem;
    background: none;
    border: none;
    padding: 0.5rem;
    cursor: pointer;
    color: var(--text-light);
    transition: var(--transition);
    min-width: auto;
    box-shadow: none;
}

.close-button:hover {
    color: var(--primary-color);
    transform: none;
}

.popup-content h3 {
    margin-bottom: 0.5rem;
    color: var(--primary-color);
    font-size: 1.5rem;
}

.popup-description {
    color: var(--text-light);
    margin-bottom: 2rem;
    font-size: 0.95rem;
}

.feedback-form {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.form-group label {
    font-weight: 500;
    color: var(--text-color);
}

.form-group select,
.form-group textarea,
.form-group input {
    padding: 0.75rem;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: var(--radius-sm);
    font-size: 0.95rem;
    transition: var(--transition);
}

.form-group select:focus,
.form-group textarea:focus,
.form-group input:focus {
    outline: none;
    border-color: var(--primary-color);
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.05);
}

.form-group textarea {
    resize: vertical;
    min-height: 100px;
}

.email-note {
    font-size: 0.85rem;
    color: var(--text-light);
    margin-top: 0.25rem;
}

.submit-button {
    background-color: var(--primary-color);
    color: white;
    padding: 0.875rem;
    border: none;
    border-radius: var(--radius-sm);
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: var(--transition);
    margin-top: 1rem;
}

.submit-button:hover {
    background-color: #0040CC;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 80, 255, 0.3);
}

/* Responsive */
@media (max-width: 768px) {
    .container {
        padding: 2rem;
    }
    
    .trim-timestamps {
        flex-direction: column;
        gap: 1rem;
    }
    
    .trim-time {
        width: 100%;
    }
    
    .time-input {
        flex: 1;
    }
    
    .secondary-button {
        width: 100%;
        margin-top: 1rem;
    }
    
    .trust-indicators {
        gap: 2rem;
    }
    
    .trust-number {
        font-size: 2rem;
    }
}

@media (max-width: 600px) {
    .container {
        padding: 1.5rem;
    }
    
    h1 {
        font-size: 2rem;
    }
    
    .upload-area {
        padding: 2rem 1rem;
    }
    
    .how-it-works-cards {
        grid-template-columns: 1fr;
    }
    
    .trust-indicators {
        flex-direction: column;
        gap: 1.5rem;
    }
    
    .popup-content {
        padding: 1.5rem;
    }
    
    .popup-content h3 {
        font-size: 1.25rem;
    }
}

.trim-controls {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 1rem;
    margin-top: 1rem;
}

.zoom-controls {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    flex-wrap: wrap;
}

.frame-button,
.zoom-button,
.copy-button,
.reset-button {
    padding: 0.5rem;
    min-width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--radius-sm);
    background-color: var(--secondary-color);
    color: #fff;
    border: none;
    cursor: pointer;
    transition: var(--transition);
}

.frame-button:hover,
.zoom-button:hover,
.copy-button:hover,
.reset-button:hover {
    opacity: 0.9;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(255, 85, 0, 0.3);
}

.frame-button:active,
.zoom-button:active,
.copy-button:active,
.reset-button:active {
    transform: scale(0.98);
}


/* Responsive styles for buttons */
@media (max-width: 768px) {
    .trim-controls {
        flex-direction: column;
        align-items: stretch;
    }

    .zoom-controls {
        justify-content: center;
        margin-top: 0.5rem;
    }

    .frame-button,
    .zoom-button,
    .copy-button,
    .reset-button {
        min-width: 36px;
        height: 36px;
    }
}

@media (max-width: 480px) {
    .zoom-controls {
        gap: 0.25rem;
    }

    .frame-button,
    .zoom-button,
    .copy-button,
    .reset-button {
        min-width: 32px;
        height: 32px;
        padding: 0.4rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,0CAA0C;IAC1C,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,0CAA0C;IAC1C,2CAA2C;IAC3C,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,yGAAyG;AAC7G;;AAEA;IACI,oBAAoB;IACpB,4DAAqD;IACrD,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,4DAAoD;IACpD,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,4DAAsD;IACtD,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,yCAAyC;IACzC,wBAAwB;IACxB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,mCAAmC;IACnC,+BAA+B;IAC/B,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,2BAA2B;IAC3B,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,uCAAuC;IACvC,2BAA2B;IAC3B,oBAAoB;IACpB,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,wBAAwB;IACxB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,6BAA6B;IAC7B,qCAAqC;AACzC;;AAEA;IACI,kCAAkC;IAClC,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,sCAAsC;IACtC,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,4CAA4C;AAChD;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,+BAA+B;IAC/B,4BAA4B;IAC5B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,+BAA+B;IAC/B,kBAAkB;IAClB,qBAAqB;IACrB,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,oBAAoB;IACpB,6BAA6B;IAC7B,wBAAwB;IACxB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,OAAO;IACP,kBAAkB;IAClB,oCAAoC;IACpC,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;IACxC,2BAA2B;AAC/B;;AAEA;IACI,6CAA6C;IAC7C,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,+BAA+B;IAC/B,oCAAoC;IACpC,sBAAsB;IACtB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,kBAAkB;IAClB,SAAS;IACT,2BAA2B;IAC3B,eAAe;IACf,UAAU;IACV,wCAAwC;IACxC,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,OAAO;IACP,2BAA2B;IAC3B,yBAAyB;IACzB,UAAU,EAAE,yCAAyC;;AAEzD;;AAEA;IACI,UAAU;IACV,2BAA2B;IAC3B,yBAAyB;IACzB,UAAU,EAAE,yCAAyC;;AAEzD;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,uCAAuC;IACvC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,oCAAoC;IACpC,+BAA+B;IAC/B,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,wCAAwC;IACxC,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,2BAA2B;IAC3B,4CAA4C;AAChD;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,eAAe;AACnB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC,kBAAkB;IAClB,sCAAsC;IACtC,uCAAuC;IACvC,+CAA+C;AACnD;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,KAAK,YAAY,EAAE;IACnB,MAAM,UAAU,EAAE;IAClB,OAAO,YAAY,EAAE;AACzB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,2DAA2D;IAC3D,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,+BAA+B;IAC/B,gBAAgB;IAChB,4BAA4B;IAC5B,6BAA6B;IAC7B,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,mCAAmC;AACvC;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,2BAA2B;IAC3B,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,mCAAmC;IACnC,wBAAwB;IACxB,oCAAoC;IACpC,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,qCAAqC;IACrC,kCAAkC;IAClC,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,mCAAmC;AACnC;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,wCAAwC;IACxC,2BAA2B;IAC3B,uBAAuB;IACvB,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mCAAmC;IACnC,+BAA+B;IAC/B,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;IAC5B,gCAAgC;AACpC;;AAEA;IACI;QACI,4BAA4B;QAC5B,UAAU;IACd;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,wBAAwB;IACxB,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;;;IAGI,gBAAgB;IAChB,oCAAoC;IACpC,+BAA+B;IAC/B,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;;;IAGI,aAAa;IACb,kCAAkC;IAClC,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,4CAA4C;AAChD;;AAEA,eAAe;AACf;IACI;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,OAAO;IACX;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;;;IAII,eAAe;IACf,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;IAC/B,wCAAwC;IACxC,WAAW;IACX,YAAY;IACZ,eAAe;IACf,6BAA6B;AACjC;;AAEA;;;;IAII,YAAY;IACZ,2BAA2B;IAC3B,4CAA4C;AAChD;;AAEA;;;;IAII,sBAAsB;AAC1B;;;AAGA,kCAAkC;AAClC;IACI;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,uBAAuB;QACvB,kBAAkB;IACtB;;IAEA;;;;QAII,eAAe;QACf,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;;;;QAII,eAAe;QACf,YAAY;QACZ,eAAe;IACnB;AACJ","sourcesContent":[":root {\n    --primary-color: hsl(0, 0%, 0%);\n    --secondary-color: #FF5500;\n    --background-color: rgb(255 251 251 / 30%);\n    --card-color: #ffffff;\n    --text-color: #1A1A2E;\n    --text-light: #4A4A65;\n    --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.08);\n    --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.12);\n    --radius-sm: 6px;\n    --radius-md: 12px;\n    --radius-lg: 24px;\n    --transition: all 0.2s ease;\n}\n\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    font-family: 'Inter', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n}\n\n@font-face {\n    font-family: 'Inter';\n    src: url('fonts/Inter-Regular.woff2') format('woff2');\n    font-weight: 400;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Inter';\n    src: url('fonts/Inter-Medium.woff2') format('woff2');\n    font-weight: 500;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Inter';\n    src: url('fonts/Inter-SemiBold.woff2') format('woff2');\n    font-weight: 600;\n    font-style: normal;\n    font-display: swap;\n}\n\nbody {\n    background-color: var(--background-color);\n    color: var(--text-color);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 100vh;\n    padding: 2rem;\n    line-height: 1.6;\n}\n\n.container {\n    max-width: 1000px;\n    width: 100%;\n    background-color: var(--card-color);\n    border-radius: var(--radius-md);\n    box-shadow: var(--shadow-md);\n    padding: 3rem;\n    margin-bottom: 3rem;\n}\n\nh1 {\n    text-align: center;\n    margin-bottom: 0.75rem;\n    color: var(--primary-color);\n    font-weight: 600;\n    font-size: 2.5rem;\n    line-height: 1.2;\n}\n\nh2 {\n    text-align: center;\n    color: var(--text-light);\n    font-weight: 500;\n    font-size: 1.25rem;\n    margin-bottom: 2rem;\n}\n\n.feature-tags {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 0.5rem;\n    margin-bottom: 1.5rem;\n}\n\n.feature-tag {\n    background-color: rgba(0, 80, 255, 0.1);\n    color: var(--primary-color);\n    padding: 0.4rem 1rem;\n    border-radius: 100px;\n    font-size: 0.875rem;\n    font-weight: 500;\n}\n\n.info-message {\n    text-align: center;\n    margin-bottom: 1.5rem;\n    color: var(--text-light);\n    font-size: 1.1rem;\n    max-width: 600px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.instructions {\n    color: var(--text-light);\n    text-align: center;\n    margin-bottom: 2rem;\n    font-size: 0.95rem;\n}\n\n.upload-area {\n    border: 2px dashed rgba(0, 0, 0, 0.1);\n    border-radius: var(--radius-md);\n    padding: 3rem 2rem;\n    text-align: center;\n    cursor: pointer;\n    margin-bottom: 2rem;\n    transition: var(--transition);\n    background-color: rgba(0, 0, 0, 0.02);\n}\n\n.upload-area:hover {\n    border-color: var(--primary-color);\n    background-color: rgba(0, 80, 255, 0.05);\n}\n\n.upload-area p {\n    margin-top: 1rem;\n    color: var(--text-light);\n}\n\n.upload-icon {\n    font-size: 3rem;\n    color: var(--primary-color);\n}\n\n.upload-icon svg {\n    width: 60px;\n    height: 60px;\n}\n\n.browse-link {\n    color: var(--primary-color);\n    font-weight: 500;\n    cursor: pointer;\n    text-decoration: underline;\n}\n\n.supported-formats {\n    font-size: 0.8rem;\n    color: var(--text-light);\n    opacity: 0.8;\n    margin-top: 0.75rem;\n}\n\n.controls {\n    display: flex;\n    justify-content: center;\n    margin-top: 2rem;\n}\n\nbutton {\n    padding: 0.875rem 2rem;\n    background-color: var(--primary-color);\n    color: #fff;\n    border: none;\n    border-radius: var(--radius-sm);\n    font-size: 1rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: var(--transition);\n    min-width: 180px;\n}\n\nbutton:hover {\n    background-color: #0040CC;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(0, 80, 255, 0.3);\n}\n\nbutton:disabled {\n    background-color: #BBC3D8;\n    cursor: not-allowed;\n    box-shadow: none;\n    transform: none;\n}\n\n.video-preview {\n    margin-top: 2rem;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background-color: #000;\n    border-radius: var(--radius-md);\n    box-shadow: var(--shadow-sm);\n    aspect-ratio: 16/9;\n    position: relative;\n    overflow: hidden;\n}\n\n.video-preview video {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: auto;\n    height: auto;\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n}\n\n.error-message {\n    background-color: #FFF5F5;\n    color: #E53E3E;\n    padding: 0.5rem;\n    font-size: 0.8rem;\n    border-radius: var(--radius-sm);\n    text-align: center;\n    margin-bottom: 1.5rem;\n    border-left: 4px solid #E53E3E;\n}\n\n.hidden {\n    display: none;\n}\n\n.file-name {\n    margin-top: 1rem;\n    font-size: 0.95rem;\n    color: var(--text-light);\n    font-weight: 500;\n}\n\n/* Tab styling */\n.tab-container {\n    margin-top: 2rem;\n    width: 100%;\n    background-color: #F7FAFC;\n    border-radius: var(--radius-md);\n    overflow: hidden;\n}\n\n.tabs {\n    display: flex;\n    background-color: #F1F5FB;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.tab-button {\n    padding: 1rem 1.5rem;\n    background-color: transparent;\n    color: var(--text-light);\n    border: none;\n    font-size: 1rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: var(--transition);\n    flex: 1;\n    text-align: center;\n    border-bottom: 3px solid transparent;\n    min-width: auto;\n    padding-top: 8px;\n    padding-bottom: 8px;\n}\n\n.tab-button:hover {\n    background-color: rgba(0, 80, 255, 0.05);\n    color: var(--primary-color);\n}\n\n.tab-button.active {\n    border-bottom: 3px solid var(--primary-color);\n    color: var(--primary-color);\n    background-color: rgba(0, 80, 255, 0.08);\n}\n\n.tab-content {\n    padding: 1.5rem;\n}\n\n.tab-pane {\n    display: none;\n    padding: 1.5rem;\n    background-color: #FFFFFF;\n    border-radius: var(--radius-sm);\n    box-shadow: var(--shadow-sm);\n}\n\n.tab-pane.active {\n    display: block;\n    animation: fadeIn 0.3s;\n}\n\n/* Trim controls */\n.select-container {\n    position: relative;\n}\n\nselect {\n    width: 100%;\n    padding: 0.875rem;\n    border-radius: var(--radius-sm);\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    background-color: #fff;\n    font-size: 1rem;\n    cursor: pointer;\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    color: var(--text-color);\n}\n\n.select-container::after {\n    content: '▼';\n    position: absolute;\n    right: 15px;\n    top: 50%;\n    transform: translateY(-50%);\n    pointer-events: none;\n    font-size: 0.8rem;\n    color: var(--text-light);\n}\n\n.hero-description {\n    text-align: center;\n    margin-bottom: 2rem;\n    font-size: 1.1rem;\n    color: var(--text-light);\n}\n\n.trim-slider-container {\n    display: flex;\n    flex-direction: column;\n    gap: 0.8rem;\n}\n\n.trim-slider {\n    position: relative;\n    height: 10px;\n    background-color: #E2E8F0;\n    border-radius: 5px;\n    margin: 2rem 0;\n}\n\n.trim-handle {\n    position: absolute;\n    width: 26px;\n    height: 26px;\n    background-color: var(--primary-color);\n    border-radius: 50%;\n    top: -8px;\n    transform: translateX(-50%);\n    cursor: pointer;\n    z-index: 5;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);\n    border: 2px solid #fff;\n    touch-action: none;\n}\n\n.trim-handle.start {\n    left: 0;\n    transform: translateX(-50%);\n    background-color: #E53E3E;\n    z-index: 2; /* Higher z-index to ensure it's on top */\n\n}\n\n.trim-handle.end {\n    left: 100%;\n    transform: translateX(-50%);\n    background-color: #cab8b8;\n    z-index: 1; /* Higher z-index to ensure it's on top */\n\n}\n\n.trim-progress {\n    position: absolute;\n    height: 10px;\n    background-color: rgba(0, 80, 255, 0.3);\n    border-radius: 5px;\n}\n\n.trim-timestamps {\n    display: flex;\n    justify-content: space-between;\n}\n\n.trim-time {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n}\n\n.trim-time label {\n    font-weight: 500;\n    color: var(--text-color);\n}\n\n.time-input {\n    width: 120px;\n    padding: 0.75rem;\n    font-size: 0.75rem;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    border-radius: var(--radius-sm);\n    text-align: center;\n    font-family: monospace;\n}\n\n.secondary-button {\n    padding: 0.75rem 1.5rem;\n    background-color: var(--secondary-color);\n    color: #fff;\n    border: none;\n    border-radius: var(--radius-sm);\n    font-size: 0.95rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: var(--transition);\n    align-self: flex-end;\n    min-width: 150px;\n}\n\n.secondary-button:hover {\n    opacity: 0.9;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(255, 85, 0, 0.3);\n}\n\n/* Audio extract styling */\n.audio-format-container {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    align-items: center;\n    padding: 2rem 0;\n}\n\n/* Spinner */\n.spinner-container {\n    display: none;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap: 1rem;\n    margin: 1rem 0;\n}\n\n#loading {\n    display: inline-block;\n    width: 60px;\n    height: 60px;\n    border: 3px solid rgba(0, 80, 255, 0.2);\n    border-radius: 50%;\n    border-top-color: var(--primary-color);\n    animation: spin 1s ease-in-out infinite;\n    -webkit-animation: spin 1s ease-in-out infinite;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n@-webkit-keyframes spin {\n    to {\n        -webkit-transform: rotate(360deg);\n    }\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n\n.loading-message {\n    color: var(--text-light);\n    font-size: 0.9rem;\n    font-weight: 500;\n    text-align: center;\n    animation: pulse 1.5s infinite;\n}\n\n@keyframes pulse {\n    0% { opacity: 0.6; }\n    50% { opacity: 1; }\n    100% { opacity: 0.6; }\n}\n\n/* Feature info cards */\n.how-it-works-cards {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 1.5rem;\n    margin-top: 3.5rem;\n}\n\n.info-card {\n    background-color: #fff;\n    border-radius: var(--radius-md);\n    padding: 1.75rem;\n    box-shadow: var(--shadow-sm);\n    transition: var(--transition);\n    border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.info-card:hover {\n    transform: translateY(-5px);\n    box-shadow: var(--shadow-md);\n    border-color: rgba(0, 80, 255, 0.1);\n}\n\n.info-card h3 {\n    margin-bottom: 1rem;\n    color: var(--primary-color);\n    font-weight: 600;\n    font-size: 1.25rem;\n}\n\n.info-card p {\n    color: var(--text-light);\n    margin-bottom: 1rem;\n    line-height: 1.6;\n}\n\n.learn-more {\n    display: inline-flex;\n    align-items: center;\n    margin-top: 1rem;\n    color: var(--primary-color);\n    text-decoration: none;\n    font-size: 0.95rem;\n    font-weight: 500;\n    gap: 0.25rem;\n}\n\n.learn-more:hover {\n    text-decoration: underline;\n}\n\n.learn-more::after {\n    content: \"→\";\n    transition: var(--transition);\n}\n\n.learn-more:hover::after {\n    transform: translateX(3px);\n}\n\n/* Buy me coffee */\n.buy-me-coffee {\n    display: flex;\n    justify-content: center;\n    margin-top: 2rem;\n}\n\n.feedback-container {\n    display: flex;\n    justify-content: center;\n    margin-top: 1rem;\n}\n\n.feedback-button {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.75rem 1.5rem;\n    background-color: var(--card-color);\n    color: var(--text-color);\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    border-radius: var(--radius-sm);\n    font-size: 0.95rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: var(--transition);\n    box-shadow: var(--shadow-sm);\n}\n\n.feedback-button:hover {\n    background-color: rgba(0, 0, 0, 0.02);\n    border-color: var(--primary-color);\n    transform: translateY(-1px);\n    box-shadow: var(--shadow-md);\n}\n\n.feedback-button svg {\n    color: var(--primary-color);\n}\n\n/* Trust indicators - New section */\n.trust-indicators {\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n    gap: 2.5rem;\n    margin: 3rem auto;\n    max-width: 700px;\n}\n\n.trust-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n}\n\n.trust-number {\n    font-size: 2.5rem;\n    font-weight: 700;\n    color: var(--primary-color);\n    margin-bottom: 0.5rem;\n}\n\n.trust-label {\n    font-size: 1rem;\n    color: var(--text-light);\n    font-weight: 500;\n}\n\n/* Privacy badge */\n.privacy-badge {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.75rem;\n    background-color: rgba(0, 80, 255, 0.05);\n    color: var(--primary-color);\n    padding: 0.75rem 1.5rem;\n    border-radius: 100px;\n    margin: 2rem auto;\n    max-width: max-content;\n}\n\n.privacy-icon {\n    flex-shrink: 0;\n}\n\n/* Popup Styles */\n.popup-overlay {\n    display: none;\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 1000;\n    align-items: center;\n    justify-content: center;\n    padding: 1rem;\n}\n\n.popup-overlay.active {\n    display: flex;\n}\n\n.popup-content {\n    background-color: var(--card-color);\n    border-radius: var(--radius-md);\n    padding: 2rem;\n    width: 100%;\n    max-width: 500px;\n    position: relative;\n    box-shadow: var(--shadow-md);\n    animation: slideIn 0.3s ease-out;\n}\n\n@keyframes slideIn {\n    from {\n        transform: translateY(-20px);\n        opacity: 0;\n    }\n    to {\n        transform: translateY(0);\n        opacity: 1;\n    }\n}\n\n.close-button {\n    position: absolute;\n    top: 1rem;\n    right: 1rem;\n    background: none;\n    border: none;\n    padding: 0.5rem;\n    cursor: pointer;\n    color: var(--text-light);\n    transition: var(--transition);\n    min-width: auto;\n    box-shadow: none;\n}\n\n.close-button:hover {\n    color: var(--primary-color);\n    transform: none;\n}\n\n.popup-content h3 {\n    margin-bottom: 0.5rem;\n    color: var(--primary-color);\n    font-size: 1.5rem;\n}\n\n.popup-description {\n    color: var(--text-light);\n    margin-bottom: 2rem;\n    font-size: 0.95rem;\n}\n\n.feedback-form {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n}\n\n.form-group {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.form-group label {\n    font-weight: 500;\n    color: var(--text-color);\n}\n\n.form-group select,\n.form-group textarea,\n.form-group input {\n    padding: 0.75rem;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    border-radius: var(--radius-sm);\n    font-size: 0.95rem;\n    transition: var(--transition);\n}\n\n.form-group select:focus,\n.form-group textarea:focus,\n.form-group input:focus {\n    outline: none;\n    border-color: var(--primary-color);\n    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.05);\n}\n\n.form-group textarea {\n    resize: vertical;\n    min-height: 100px;\n}\n\n.email-note {\n    font-size: 0.85rem;\n    color: var(--text-light);\n    margin-top: 0.25rem;\n}\n\n.submit-button {\n    background-color: var(--primary-color);\n    color: white;\n    padding: 0.875rem;\n    border: none;\n    border-radius: var(--radius-sm);\n    font-size: 1rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: var(--transition);\n    margin-top: 1rem;\n}\n\n.submit-button:hover {\n    background-color: #0040CC;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(0, 80, 255, 0.3);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n    .container {\n        padding: 2rem;\n    }\n    \n    .trim-timestamps {\n        flex-direction: column;\n        gap: 1rem;\n    }\n    \n    .trim-time {\n        width: 100%;\n    }\n    \n    .time-input {\n        flex: 1;\n    }\n    \n    .secondary-button {\n        width: 100%;\n        margin-top: 1rem;\n    }\n    \n    .trust-indicators {\n        gap: 2rem;\n    }\n    \n    .trust-number {\n        font-size: 2rem;\n    }\n}\n\n@media (max-width: 600px) {\n    .container {\n        padding: 1.5rem;\n    }\n    \n    h1 {\n        font-size: 2rem;\n    }\n    \n    .upload-area {\n        padding: 2rem 1rem;\n    }\n    \n    .how-it-works-cards {\n        grid-template-columns: 1fr;\n    }\n    \n    .trust-indicators {\n        flex-direction: column;\n        gap: 1.5rem;\n    }\n    \n    .popup-content {\n        padding: 1.5rem;\n    }\n    \n    .popup-content h3 {\n        font-size: 1.25rem;\n    }\n}\n\n.trim-controls {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 1rem;\n    margin-top: 1rem;\n}\n\n.zoom-controls {\n    display: flex;\n    gap: 0.5rem;\n    align-items: center;\n    flex-wrap: wrap;\n}\n\n.frame-button,\n.zoom-button,\n.copy-button,\n.reset-button {\n    padding: 0.5rem;\n    min-width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: var(--radius-sm);\n    background-color: var(--secondary-color);\n    color: #fff;\n    border: none;\n    cursor: pointer;\n    transition: var(--transition);\n}\n\n.frame-button:hover,\n.zoom-button:hover,\n.copy-button:hover,\n.reset-button:hover {\n    opacity: 0.9;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(255, 85, 0, 0.3);\n}\n\n.frame-button:active,\n.zoom-button:active,\n.copy-button:active,\n.reset-button:active {\n    transform: scale(0.98);\n}\n\n\n/* Responsive styles for buttons */\n@media (max-width: 768px) {\n    .trim-controls {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .zoom-controls {\n        justify-content: center;\n        margin-top: 0.5rem;\n    }\n\n    .frame-button,\n    .zoom-button,\n    .copy-button,\n    .reset-button {\n        min-width: 36px;\n        height: 36px;\n    }\n}\n\n@media (max-width: 480px) {\n    .zoom-controls {\n        gap: 0.25rem;\n    }\n\n    .frame-button,\n    .zoom-button,\n    .copy-button,\n    .reset-button {\n        min-width: 32px;\n        height: 32px;\n        padding: 0.4rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
